import AbstractModule from '../../core/AbstractModule';
import RouteBuilder from '../../core/RouteBuilder';
import formComponent from './QualityMentoringFormPage.vue';

class FormModule extends AbstractModule {
  private $routes: any = [];

  getRoutes(): any[] {
    let routes = new RouteBuilder()
      .path('/form/:id(1|2|3|4|5)')
      .meta('authenticated', true)
      .meta('onboarded', true)
      .component(formComponent)
      .build();
    return routes;
  }
}

// eslint-disable-next-line no-new
new FormModule();
